import { SwitchButton, SwitchField } from 'react-aria-components';
import { cx } from './cx';

export interface SwitchProps {
  /** Whether the switch is on. */
  isSelected: boolean;
  /** Change handler. */
  onChange: (isSelected: boolean) => void;
  /** Visible label text to the right of the control. */
  label: string;
  isDisabled?: boolean;
  className?: string;
}

/**
 * On/off toggle switch (react-aria `SwitchField` + `SwitchButton`). An
 * animated pill: the track fills with the brand solid and the thumb slides
 * across on select, with a keyboard focus ring. Colors come from foundation
 * tokens (the thumb uses the white contrast primitive).
 */
export const Switch = ({
  isSelected,
  onChange,
  label,
  isDisabled,
  className,
}: SwitchProps) => (
  <SwitchField
    isSelected={isSelected}
    onChange={onChange}
    isDisabled={isDisabled}
  >
    <SwitchButton
      className={cx(
        'group flex select-none items-center gap-2.5 text-sm text-fg-secondary outline-none',
        isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      )}
    >
      <span
        className={cx(
          'relative flex h-6 w-11 shrink-0 items-center rounded-full px-0.5',
          'bg-muted-strong transition-colors duration-300 ease-in-out',
          'group-selected:bg-brand-solid',
          'group-focus-visible:ring-4 group-focus-visible:ring-[rgb(var(--c-ring)/0.24)]',
        )}
      >
        <span
          className={cx(
            'size-5 rounded-full bg-white shadow-md',
            'transition-transform duration-300 ease-in-out',
            'group-selected:translate-x-5',
          )}
        />
      </span>
      {label}
    </SwitchButton>
  </SwitchField>
);
